import { PAGINATION_HEADER_CONTINUATION_TOKEN, } from "../data/paginated-result";
import { ApiError } from "@aws-amplify/api";
import { NotFoundError } from "../error/error";
export const API_NAME_VELAVU = "Velavu-API";
/**
 * Helper function to read an Amplify API operation
 * to a JSON type
 */
export async function operationToJSON(op) {
    const response = await op.response;
    return (await response.body.json());
}
export async function operationToPaginatedJSON(op) {
    const response = await op.response;
    const data = (await response.body.json());
    const continuationToken = response.headers[PAGINATION_HEADER_CONTINUATION_TOKEN];
    return { data, continuationToken };
}
export function paginateAPIOptions(params, options = {}) {
    if (params === undefined) {
        return options;
    }
    //Copy the input object
    const newOptions = { ...options };
    const newQueryParams = newOptions.queryParams === undefined
        ? {}
        : { ...newOptions.queryParams };
    //Add the query params
    if (params.continuationToken !== undefined) {
        newQueryParams["continuation_token"] = params.continuationToken;
    }
    if (params.limit !== undefined) {
        newQueryParams["limit"] = String(params.limit);
    }
    //Return the updated object
    newOptions.queryParams = newQueryParams;
    return newOptions;
}
export function valueToDocumentType(value) {
    //Map undefined to null
    if (value === undefined) {
        return null;
    }
    //Make sure all array elements are document types
    if (Array.isArray(value)) {
        return value
            .filter((item) => item !== undefined)
            .map((valueItem) => valueToDocumentType(valueItem));
    }
    if (typeof value === "object" && value !== null) {
        return Object.entries(value).reduce((acc, [key, value]) => {
            //Skip undefined values
            if (value !== undefined) {
                acc[key] = valueToDocumentType(value);
            }
            return acc;
        }, {});
    }
    //Return all other types as-is
    return value;
}
/**
 * Maps a record with simple JavaScript primitives to a record
 * with string-only values
 */
export function simplifyStringRecord(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        //Skip undefined values
        if (value !== undefined) {
            acc[key] = String(value);
        }
        return acc;
    }, {});
}
/**
 * Normalizes an Amplify error to a local error
 */
export function normalizeError(error) {
    if (error instanceof ApiError
        && error.response !== undefined
        && error.response.statusCode === 404) {
        return new NotFoundError(error.response.body ?? "404 Not found", error);
    }
    else {
        return error;
    }
}
/**
 * Normalizes the error of a promise
 */
export function normalizePromiseError(promise) {
    return promise.catch((error) => Promise.reject(normalizeError(error)));
}
//# sourceMappingURL=amplify-utils.js.map